'use strict'

import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import { ChromePicker, ColorResult } from 'react-color'

interface ColorPickerButtonProps {
  onColorChange?: (color: ColorResult) => void;
  defaultColor?: string;
  desc?: string;
  children?: React.ReactNode;
}

const ColorPickerButton: React.FC<ColorPickerButtonProps> = ({ 
  onColorChange,
  desc,
  defaultColor = '#fff',
  children
}) => {
  const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);
  const [color, setColor] = useState<string>(defaultColor);

  // Watch for changes to defaultColor and update state without triggering onColorChange
  useEffect(() => {
    setColor(defaultColor);
  }, [defaultColor]);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleColorChange = (newColor: ColorResult) => {
    setColor(newColor.hex);
    if (onColorChange) {
      onColorChange(newColor);
    }
  };

  const popover: React.CSSProperties = {
    position: 'absolute',
    zIndex: 2,
  };

  const cover: React.CSSProperties = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  };

  return (
    <div style={{ marginBottom: '1.2rem' }}>
      <button
        className="btn"
        onClick={handleClick}
        style={{
          backgroundColor: color, 
          color: '#fff',
          borderColor: `color-mix(in srgb, ${color} 90%, black)`
        }}
      >
        {children || 'Select Color'} <i className="mdi mdi-eyedropper"></i>
      </button>
      {desc && <Form.Text>{desc}</Form.Text>}
      {displayColorPicker && (
        <div style={popover}>
          <div style={cover} onClick={handleClose} />
          <ChromePicker color={color} onChange={handleColorChange} />
        </div>
      )}
    </div>
  );
};

export default ColorPickerButton;